import { render, staticRenderFns } from "./TabMoonriseMoonset.vue?vue&type=template&id=53bda970&scoped=true"
import script from "./TabMoonriseMoonset.vue?vue&type=script&lang=js"
export * from "./TabMoonriseMoonset.vue?vue&type=script&lang=js"
import style0 from "./TabMoonriseMoonset.vue?vue&type=style&index=0&id=53bda970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bda970",
  null
  
)

export default component.exports